<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 16.062 15.485"
  >
    <g>
      <path
        d="M14.456 3.26h-3.213V1.63A1.613 1.613 0 0 0 9.637 0H6.425a1.613 1.613 0 0 0-1.606 1.63v1.63H1.606a1.606 1.606 0 0 0-1.6 1.63v8.965a1.613 1.613 0 0 0 1.606 1.63h12.85a1.613 1.613 0 0 0 1.606-1.63V4.89a1.613 1.613 0 0 0-1.612-1.63ZM6.425 1.63h3.212v1.63H6.425Zm8.031 12.225H1.606V4.89h12.85Z"
        fill="currentColor"
      />
      <path d="M.587 8.392h14.245" fill="none" />
      <g
        fill="none"
        stroke="currentColor"
        stroke-linejoin="round"
        stroke-width="1.2"
      >
        <path stroke="none" d="M6.031 6.444h4v4h-4z" />
        <path d="M6.631 7.044h2.8v2.8h-2.8z" />
      </g>
      <path
        d="M.915 8.392h5.29"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path
        d="M8.915 8.444h6.051"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
      />
    </g>
  </svg>
</template>
